import * as React from 'react';
import { ActionPlanRiskConsequence, ActionPlanRiskConsequences, ActionPlanRiskLikelihood, ActionPlanRiskLikelihoods } from '../../amorg-common';
import { Flex } from '../compositeComponents/FlexHelpers';
import { ProblemType, ProblemTypes, txt } from '../../txt';
import { H2 } from '../typography/Heading';
import { Button } from '../button/Button';
import { CardButton } from '../CardButton';
import { AnimatedCollapsibleContent } from '../collapsible/AnimatedCollapsibleContent';

type DetailedRiskAssessmentEvaluatorProps = {
    consequence: ActionPlanRiskConsequence,
    likelihood: ActionPlanRiskLikelihood,
    onChange: (consequence: ActionPlanRiskConsequence, likelihood: ActionPlanRiskLikelihood) => void;
};
export function DetailedRiskAssessmentEvaluator (props: DetailedRiskAssessmentEvaluatorProps): JSX.Element
{
    const [problemType, setProblemType] = React.useState<ProblemType | undefined>(undefined);

    function handleProblemTypeChange(pt: ProblemType)
    {
        setProblemType(pt);
        // Must be called to enable update button
        props.onChange(props.consequence, props.likelihood);
    }

    return (
        <Flex flexDirection="column" gap={16} grow='1'>
            
            <Flex gap={8} flexWrap='wrap'>
                {ProblemTypes.map(pt =>
                    <Button key={pt}
                        variant={problemType === pt ? 'light' : 'outlined' }
                        onClick={() => handleProblemTypeChange(pt)}
                        text={txt.problemType(pt)} />
                )}
            </Flex>

            <AnimatedCollapsibleContent open={!!problemType}>
                <Flex flexDirection="column" gap={32}>
                    <div>
                        <H2>Sandsynlighed</H2>
                        <Flex flexDirection="column" gap={8}>
                            {...ActionPlanRiskLikelihoods.map(likelihood =>
                                <CardButton key={likelihood}
                                    variant={props.likelihood === likelihood ? 'light' : 'outlined' }
                                    onClick={() => {
                                        props.onChange(props.consequence, likelihood);
                                    }}>
                                    {txt.riskLikelihood(likelihood)}
                                </CardButton>
                            )}
                        </Flex>
                    </div>
                            
                    <div>
                        <H2>Konsekvens</H2>
                        <Flex flexDirection="column" gap={8}>
                            {...ActionPlanRiskConsequences.map(consequence =>
                                <CardButton key={consequence}
                                    variant={props.consequence === consequence ? 'light' : 'outlined' }
                                    onClick={() => {
                                        props.onChange(consequence,  props.likelihood);
                                    }}>
                                    {txt.riskProblemTypeConsequence(problemType, consequence)}
                                </CardButton>
                            )}
                        </Flex>
                    </div>
                </Flex>
            </AnimatedCollapsibleContent>
        </Flex>
    );
}